export function getdata() {
	let obj = {
		formlist: [{
			prop: "textSplitType",
			label: "文本分割类型",
			type: "input",
			width: "200px",

		}],
		searchlist: [{
				prop: "templateName",
				label: '模板名称',
				type: "input",
			}, {
				prop: "templateType",
				label: '模板类型',
				type: "select",
				selectval: [{
					label: "导入",
					value: "1"
				}, {
					label: "导出",
					value: "2"
				}]
			},
			{
				prop: "entityName",
				label: '模板用途',
				type: "input",
			}
		],
		searchdata: {
			templateName: '',
			templateType: '',
			entityName: '',
		},
		headData: [{
				title: "模板名称",
				prop: "templateName",
				width: "100"
			},
			{
				title: "模板类型",
				prop: "templateType",
				width: "100",
				custom: true
			},
			{
				title: "模板用途",
				prop: "entityName",
				width: "100",
				custom: true

			},
			{
				title: "数据源类型",
				prop: "suffixType",
				width: "100"
			},
			{
				title: "创建时间",
				prop: "createTime",
				width: "100"
			},
			{
				title: "更新时间",
				prop: "updateTime",
				width: "100"
			}, {
				title: "操作",
				prop: "cz",
				width: "200",
				fixed: "right",
				custom: true
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		headDatays: [{
			title: "列名",
			prop: "name",
			width: "80"
		}, {
			title: "字段名",
			prop: "columnName",
			width: "80"
		}, {
			title: "数据类型",
			prop: "fieldType",
			width: "80"
		}, {
			title: "映射类型",
			prop: "mappingType",
			width: "150",
			custom: true
		}, {
			title: "值",
			prop: "mappingValue",
			width: "140",
			custom: true
		}, {
			title: "表达式",
			prop: "mappingExpression",
			width: "80",
			custom: true
		}, {
			title: "精度",
			prop: "mappingPrecision",
			width: "80",
			custom: true
		}],



		headDatapz: [{
			title: "列名",
			prop: "name",
			width: "50"
		}, {
			title: "日期格式",
			prop: "dateFormat",
			width: "50",
			custom: true
		}, {
			title: "精度",
			prop: "mappingPrecision",
			width: "50",
			custom: true
		}],
	}
	return obj
}
